module.exports = __webpack_public_path__ + "static/media/pass2.0809312d.png";